import React from 'react'
import Card from '@mui/material/Card';
import { outlineBorder } from '../../Themes/Images';

function LoginCard({ children, containerStyles, cardStyles }) {
    return (
        <div
            style={{
                backgroundImage: `url(${outlineBorder})`,
                backgroundRepeat: 'inherit',
                padding: '15px',
                ...containerStyles
            }
            }
        >
            <Card sx={{
                minWidth: 500,
                background: "rgba(255, 255, 255, 0.05)",
                boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
                backdropFilter: "blur(5px)",
                WebkitBackdropFilter: "blur(5px)",
                ...cardStyles
            }}>
                {children}
            </Card>
        </div >

    )
}

export default LoginCard